import React from 'react';
import PropTypes from 'prop-types';

import formikPropTypes from './formikPropTypes';

import {
  STRING_FIELD_NO_RESUME,
} from '../labels';

import CheckboxField from '../CheckboxField';

export function NoResumeField({
  name, onChange, formikProps: {
    handleChange, isSubmitting, values,
  },
}) {
  const handleInputChange = (e) => {
    onChange(e);
    handleChange(e);
  };

  return (
    <CheckboxField
      checked={values[name]}
      disabled={isSubmitting}
      label={STRING_FIELD_NO_RESUME}
      name={name}
      onChange={handleInputChange}
    />
  );
}

NoResumeField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  formikProps: formikPropTypes.isRequired,
};

NoResumeField.defaultProps = {
  onChange: () => {},
};

export default NoResumeField;
